import fetcher, { makeFetcher } from '@sls-react/api/fetcher';
import {
  RailsConfigEmblem,
  RailsSortConfig,
  RailsWebConfiguration,
} from '@sls-react/typings/services/rails/configuration';
import { FacetContext } from '@sls-react/typings/services/rails/facets';
import { RailsSale } from '@sls-react/typings/services/rails/sales';

export const fetchWebConfiguration = () =>
  fetcher<RailsWebConfiguration>('/v1/configs/web', {
    params: { platform: 'web' },
  });

export const fetchSortConfig = (context?: FacetContext) =>
  fetcher<RailsSortConfig>('/v1/config/item_sort', {
    params: {
      context,
      platform: 'web',
    },
  });

export const fetchSales = makeFetcher<RailsSale[]>(() => '/v1/sales');

export const fetchEmblemsConfiguration = () =>
  fetcher<RailsConfigEmblem[]>('/v1/config/emblems');
